const indexPrefix = (i) =>
  `${i === 1 ? "1st" : i === 2 ? "2nd" : i === 3 ? "3rd" : i + "th"}`;

export default indexPrefix;
